import React, { useEffect, useState, useRef } from "react"
import get from "lodash/get"
import { API_URL } from "../../../../constants/constants"
import { getAllRiskManagementSetting } from "store/riskManagement/actions"
import axios from "axios"
import { useSelector, useDispatch } from "react-redux"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Label,
  Input,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
} from "reactstrap"
import {
  getTokenFromLocalStorage,
  showErrorMessages,
  hasPermission,
} from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { setFeaturesCall } from "helpers/repository"

export default function Features(props) {
  const dispatch = useDispatch()

  const [send_sms, setSendSms] = useState("")
  const [autolock_account, setAutoLockAccount] = useState("")
  const [attempts, setAttempts] = useState("")
  const [number_fraud_ticket, setNumberFraudTicket] = useState("")

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setSendSms(get(props, "data.send_sms", ""))
    setAutoLockAccount(get(props, "data.autolock_account", ""))
    setAttempts(get(props, "data.attempts", ""))
    setNumberFraudTicket(get(props, "data.number_fraud_ticket", ""))
  }, [])

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  const handleClick = () => {
    toggle()
  }

  const handleSubmit = e => {
    e.preventDefault()
    var bodyFormData = new FormData()

    bodyFormData.append("send_sms", send_sms)
    bodyFormData.append("autolock_account", autolock_account)
    bodyFormData.append("attempts", attempts)
    bodyFormData.append("number_fraud_ticket", number_fraud_ticket)

    setFeaturesCall(bodyFormData)
      .then(function (response) {
        //handle success
        showMessage("success", response.data.message)
        dispatch(getAllRiskManagementSetting())
      })
      .catch(function (response) {
        //handle error
        showErrorMessages(response)
      })

    toggle()
  }

  return (
    <React.Fragment>
      <Col>
        <Card>
          <CardBody>
            <CardTitle className="mb-4">Features</CardTitle>

            <Form>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">SMS On Winnings</Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.send_sms", "") == 1 ? "Yes" : "No"}
                  </p>
                </Col>
              </div>

              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Auto Lock Account</Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.autolock_account", "") == 1
                      ? "Yes"
                      : "No"}
                  </p>
                </Col>
              </div>

              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    Attempts Before Autolock
                  </Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(get(props, "data.attempts", "")).toLocaleString('en-GB')}
                  </p>
                </Col>
              </div>

              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Number fraud Tickets</Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(get(props, "data.number_fraud_ticket", "")).toLocaleString('en-GB')}
                  </p>
                </Col>
              </div>

              {hasPermission("update-parameters") && (
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    type="button"
                    color="primary"
                    className=""
                    onClick={handleClick}
                  >
                    Edit
                  </Button>
                </div>
              )}
            </Form>
          </CardBody>
        </Card>
      </Col>

      <Modal centered isOpen={isOpen} toggle={toggle}>
        <ModalHeader tag="h4" toggle={toggle}>
          {"Update Features"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <div className="mb-3">
              <Label htmlFor="send_sms_Input">SMS On Winnings</Label>
              <Row>
                <Col lg={2}>
                  <div className="form-check mb-3">
                    <input
                      id="smsYes"
                      className="form-check-input"
                      type="radio"
                      value="1"
                      defaultChecked
                      onChange={e => {
                        setSendSms(e.target.value)
                      }}
                      checked={send_sms == 1}
                    />
                    <label className="form-check-label" htmlFor="smsYes">
                      Yes
                    </label>
                  </div>
                </Col>
                <Col lg={2}>
                  <div className="form-check">
                    <input
                      id="smsNo"
                      className="form-check-input"
                      type="radio"
                      value="0"
                      onChange={e => {
                        setSendSms(e.target.value)
                      }}
                      checked={send_sms == 0}
                    />
                    <label className="form-check-label" htmlFor="smsNo">
                      No
                    </label>
                  </div>
                </Col>
                <Col lg={8}></Col>
              </Row>
            </div>

            <div className="mb-3">
              <Label htmlFor="autolock_account_Input">Auto Lock Account</Label>
              <Row>
                <Col lg={2}>
                  <div className="form-check mb-3">
                    <input
                      id="accountLockYes"
                      className="form-check-input"
                      type="radio"
                      value="1"
                      onChange={e => {
                        setAutoLockAccount(e.target.value)
                      }}
                      checked={autolock_account == 1}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="accountLockYes"
                    >
                      Yes
                    </label>
                  </div>
                </Col>
                <Col lg={2}>
                  <div className="form-check mb-3">
                    <input
                      id="accountLockNo"
                      className="form-check-input"
                      type="radio"
                      value="0"
                      onChange={e => {
                        setAutoLockAccount(e.target.value)
                      }}
                      checked={autolock_account == 0}
                    />
                    <label className="form-check-label" htmlFor="accountLockNo">
                      No
                    </label>
                  </div>
                </Col>
                <Col lg={8}></Col>
              </Row>
            </div>

            <div className="mb-3">
              <Label htmlFor="attempts_Input">Attempts Before Autolock</Label>
              <Input
                type="text"
                className="form-control"
                id="attempts_Input"
                name={"AttemptsBeforeAutolock"}
                value={attempts}
                required
                onChange={e => {
                  setAttempts(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="number_fraud_ticket_Input">
                Number fraud Tickets
              </Label>
              <Input
                type="text"
                className="form-control"
                id="number_fraud_ticket_Input"
                name={"NumberFraudTicket"}
                value={number_fraud_ticket}
                required
                onChange={e => {
                  setNumberFraudTicket(e.target.value)
                }}
              />
            </div>

            <div className="text-end">
              <Button type="submit" className="btn btn-success w-md">
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}
